module.exports = __webpack_public_path__ + "img/logo.6a6b5089.png";